// extracted by mini-css-extract-plugin
export var modal = "_kc-0";